import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ConnectionService } from '../../connection.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-proposals',
  templateUrl: './proposals.component.html',
  styleUrls: ['./proposals.component.css']
})
export class ProposalsComponent implements OnInit {
  listPro = []; listSR = []; proRes: any; SrPro: any = {}; proId; token = localStorage.getItem('Sastana_Token'); modalRef: BsModalRef;
  @ViewChild('beforeLogin') beforeLogin: TemplateRef<any>;
  @ViewChild('srForm') srForm: TemplateRef<any>;
  @ViewChild('appsrForm') appsrForm: TemplateRef<any>;
  @ViewChild('proposalForm') proposalForm: TemplateRef<any>;
  constructor(private conn: ConnectionService, private alert: ToastrService, private modalService: BsModalService, private route: Router, private actRoute: ActivatedRoute) {

    this.actRoute.params.subscribe((params) => {
      this.proId = this.actRoute.snapshot.queryParamMap.get('id');
      if (this.proId == null || this.proId == undefined || this.proId == "undefined") {
        this.alert.error("Invalid Request");
        this.route.navigate(['/']);
      }
      var data = { "proId": this.proId };
      this.conn.postUrl('proposal/proposal', data).subscribe((res: any) => {

        this.proRes = res.result;
      })

    });

  }

  ngOnInit() {
    this.getSR();
  }

  getSR() {
    this.conn.getUrl('proposal/listSuperRepresentatives').subscribe((res: any) => {
      this.listSR = res.result;
      for (var j = 0; j < this.listSR.length; j++) {
        this.listSR[j].position = j + 1;
      }
    });
  }

}
